import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { ROTULO_TIPO_PENDENCIA, type PendenciaAtivo, type TipoPendenciaAtivo } from './ativos.utils';

/** 'nenhum' = lista normal; 'todas' = qualquer pendência; ou um tipo específico. */
export type FiltroPendenciaAtivo = 'nenhum' | 'todas' | TipoPendenciaAtivo;

interface PendenciasFiltroBarraProps {
  pendenciasPorId: Map<string, PendenciaAtivo[]>;
  filtro: FiltroPendenciaAtivo;
  onChange: (filtro: FiltroPendenciaAtivo) => void;
}

export function atendeFiltroPendenciaAtivo(pendencias: PendenciaAtivo[] | undefined, filtro: FiltroPendenciaAtivo): boolean {
  if (filtro === 'nenhum') return true;
  if (filtro === 'todas') return (pendencias?.length ?? 0) > 0;
  return Boolean(pendencias?.some((p) => p.tipo === filtro));
}

/** Faixa de pendências do cadastro com filtro por tipo (quantos ativos têm cada uma). */
export default function PendenciasFiltroBarra({ pendenciasPorId, filtro, onChange }: PendenciasFiltroBarraProps) {
  const listas = Array.from(pendenciasPorId.values());
  const total = listas.filter((p) => p.length > 0).length;
  if (total === 0) return null;

  const porTipo = new Map<TipoPendenciaAtivo, number>();
  for (const pendencias of listas) {
    Array.from(new Set(pendencias.map((p) => p.tipo))).forEach((tipo) => porTipo.set(tipo, (porTipo.get(tipo) ?? 0) + 1));
  }
  const tipos = Array.from(porTipo.entries()).sort((a, b) => b[1] - a[1]);

  return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg border-l-4 border-red-500 bg-amber-100 px-4 py-3">
      <ExclamationTriangleIcon className="h-6 w-6 shrink-0 text-red-600" />
      <p className="text-sm font-semibold text-red-800">
        {total} {total === 1 ? 'ativo com pendência' : 'ativos com pendência'} no cadastro
      </p>
      <div className="ml-auto flex flex-wrap items-center gap-2">
        <select
          className="input-primary py-1 text-xs"
          value={filtro === 'nenhum' ? '' : filtro}
          onChange={(e) => onChange((e.target.value || 'nenhum') as FiltroPendenciaAtivo)}
          aria-label="Filtrar por tipo de pendência"
        >
          <option value="">Ver pendências...</option>
          <option value="todas">Todas ({total})</option>
          {tipos.map(([tipo, quantidade]) => (
            <option key={tipo} value={tipo}>
              {ROTULO_TIPO_PENDENCIA[tipo]} ({quantidade})
            </option>
          ))}
        </select>
        {filtro !== 'nenhum' && (
          <button
            type="button"
            onClick={() => onChange('nenhum')}
            className="rounded-md bg-red-600 px-3 py-1 text-xs font-semibold text-white hover:bg-red-700"
          >
            Mostrar todos
          </button>
        )}
      </div>
    </div>
  );
}
